/**
 * 메인 페이지 API 서비스
 */

import { apiClient } from '../../../shared/services/api';

export interface RecentPost {
  id: number;
  title: string;
  createdAt: string;
  boardType: string;
}

export interface RecentPostsResponse {
  posts: RecentPost[];
}

export const mainService = {
  /**
   * 메인 페이지용 최신 게시글 조회
   */
  getRecentPosts: async (limit: number = 6): Promise<RecentPostsResponse> => {
    // limit은 최대 6개로 제한
    const validLimit = Math.min(Math.max(1, limit), 6);
    // API 실제 응답: { data: { posts: [...] } }
    // apiClient.get<T>의 T는 HTTP 응답 body 타입
    const response = await apiClient.get<{ data: RecentPostsResponse }>(`/main/recent-posts?limit=${validLimit}`);

    // response = { data: { posts: [...] } }
    // response.data = { posts: [...] }
    return response.data;
  },
};
